import EditBlogTermsModal from './EditBlogTermsModal';

const EditBlogAuthorModal = ({ modalDetails }) => (
  <EditBlogTermsModal modalDetails={modalDetails} kind="authors" />
);

export default EditBlogAuthorModal;
